export function getTicket() {
  const ticket: any = localStorage.getItem("ticket")
  const json: any = JSON.parse(ticket)
  return json
}

export function getMenuItems() {
  const menu: any = localStorage.getItem("menuItems")
  const json: any = JSON.parse(menu)
  return json
}

export function getRoles() {
  const menu: any = localStorage.getItem("roles")
  const json: any = JSON.parse(menu)
  return json
}

export function getKey(i: any = null) {
  return new Date().getTime() + i
}

export function daysInThisMonth(month: any = null) {
  var now = new Date();
  return new Date(now.getFullYear(), month || now.getMonth()+1, 0).getDate();
}
